import { render, staticRenderFns } from "./updateCommunicationPath.vue?vue&type=template&id=876aedb8&"
import script from "./updateCommunicationPath.vue?vue&type=script&lang=js&"
export * from "./updateCommunicationPath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports